<template>
  <el-form ref="form" :model="curInput.checkbox" :rules="rules" label-width="100px">
    <el-form-item label="最少选择限制" prop="select_min">
      <el-input type="number" v-model.number="curInput.checkbox.select_min" class="h-40 w-200"></el-input>
      <div class="form-tips">填0代表不限制</div>
    </el-form-item>
    <el-form-item label="最多选择限制" prop="select_max">
      <el-input type="number" v-model.number="curInput.checkbox.select_max" class="h-40 w-200"></el-input>
      <div class="form-tips">填0代表不限制</div>
    </el-form-item>
    <el-form-item label="是否显示全选" prop="show_select_all">
      <el-radio-group v-model="curInput.checkbox.show_select_all">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <option-config :curInput="curInput" :selectConfig="curInput.checkbox_option" :onlyName="true" :chooseMultiply="true" :maxCount="curInput.checkbox.select_max"></option-config>
  </el-form>
</template>

<script>
  import optionConfig from './optionConfig'
  export default {
    props: ['curInput'],
    data() {
      return {
        rules: {
          select_min: [],
          select_max: []
        }
      }
    },
    components: {
      optionConfig
    },
    created() {
      let vaildMin = { validator: this.vaildMin, trigger: 'blur' }
      let vaildMax = { validator: this.vaildMax, trigger: 'blur' }
      this.rules.select_min.push(vaildMin)
      this.rules.select_max.push(vaildMax)
    },
    methods: {
      vaildMin(rule, value, callback) {
        if (this.curInput.checkbox.select_max && value > this.curInput.checkbox.select_max) {
          callback('最少选择限制必须小于最多选择限制')
        } else {
          callback()
        }
      },
      vaildMax(rule, value, callback) {
        console.log(value)
        if (this.curInput.checkbox.select_min && value && value < this.curInput.checkbox.select_min) {
          callback('最多选择限制必须大于最少选择限制')
        } else {
          callback()
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// checkboxConfig.vue?341937c0